import React from "react";
import { ReactComponent as IconSearch } from "../../shared/assets/Icons/IconsSearch.svg";

interface GenericFilterProps {
	searchColumn: string;
	onSearchColumnChange: (column: string) => void;
	searchTerm: string;
	onSearchTermChange: (term: string) => void;
	columnOptions: string[];
	heightClass?: string;
}

export const GenericFilter: React.FC<GenericFilterProps> = ({
	searchColumn,
	onSearchColumnChange,
	searchTerm,
	onSearchTermChange,
	columnOptions,
	heightClass,
}) => {
	const finalHeightClass = heightClass || "h-[30px]";

	return (
		<div className="flex items-center flex-1 sm:flex-none min-w-0 max-w-full">
			<div
				className={`
          ${finalHeightClass}
          border border-semantic-border-secondary
          rounded
          overflow-hidden
          bg-semantic-bg-secondary
          flex items-center
          w-full sm:w-auto
          min-w-0
        `}
			>
				<span
					className={`
            flex items-center justify-center flex-shrink-0
            ${finalHeightClass}
            px-2
          `}
				>
					<IconSearch className="w-4 h-4 text-semantic-fg-primary" />
				</span>

				<select
					className={`
            ${finalHeightClass}
            flex-shrink-0
            border-l border-semantic-border-secondary
            px-2
            text-sm
            outline-none
            focus:ring-0
            bg-semantic-bg-primary-alt
            text-semantic-text-primary
          `}
					value={searchColumn}
					onChange={(e) => onSearchColumnChange(e.target.value)}
				>
					{columnOptions.map((opt) => (
						<option key={opt} value={opt}>
							{opt}
						</option>
					))}
				</select>

				<input
					type="text"
					className={`
            ${finalHeightClass}
            flex-1 min-w-0
            sm:flex-none sm:w-[200px]
            text-sm
            px-2
            outline-none
            focus:ring-0
            border-l border-semantic-border-secondary
            bg-semantic-bg-primary-alt
          `}
					placeholder={`Search by ${searchColumn === "All" ? "All" : searchColumn
						}`}
					value={searchTerm}
					onChange={(e) => onSearchTermChange(e.target.value)}
				/>
			</div>
		</div>
	);
};
